import React from 'react';
import { change } from 'redux-form';
import AutocompleteSelect from 'chameleon/ui-stack/ui/forms/autocomplete-select';

/**
 * Wrapper for AutocompleteSelect component to use with ReduxForm.
 * */
const AutocompleteSelectField = (props) => {
  const {
    input: { name: fieldName },
    meta: { form, dispatch },
    onChange,
    className,
    options,
    value,
    placeholder,
    disableDropdown,
    selectOptions = {},
    portalContainerClassName,
  } = props;

  const onSelectChange = (newSelection) => {
    dispatch(change(form, fieldName, newSelection.value));
    onChange && onChange(form, newSelection.value);
  };

  return (
    <AutocompleteSelect
      onChange={onSelectChange}
      className={className}
      options={options}
      value={value}
      placeholder={placeholder}
      disableDropdown={disableDropdown}
      {...selectOptions}
      portalContainerClassName={portalContainerClassName}
    />
  );
};

AutocompleteSelectField.displayName = 'AutocompleteSelectField';

export default AutocompleteSelectField;
